import React from "react"
import { WorkshopHeadingTextType } from "../../types/mainModulTypes"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseRichtext from "../common/BaseRichtext"

export default function WorkshopHeadingText(props: WorkshopHeadingTextType) {
    return (
        <div className="max-w-content mx-auto px-4 lg:px-0">
            <div className="max-w-content-sm">
                <BaseSubheadline label={props.workshopHeadingTextHeading} />
                <BaseRichtext content={props.workshopHeadingTextText} />
            </div>
        </div>
    )
}
